export const Config = {
	environment: 'development',
	sentry     : {
		dsn        : 'https://ee39121b37fba052442568afdfba68b5@trace.windware.net/6',
		sample_rate: 1,
	},
}
